import { render, staticRenderFns } from "./Page-SaleCompleteScreen.vue?vue&type=template&id=16ff3032"
import script from "./Page-SaleCompleteScreen.vue?vue&type=script&lang=js"
export * from "./Page-SaleCompleteScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports